import { useRef } from 'react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import { useTranslation } from 'next-i18next';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ShowroomsList/ShowroomsList.styles';
import { IPointOfPresence } from '@features/checkout/typescript';
import Heading from '@components/Heading/Heading';
import { getShowroomName } from '@utils/showroom';
import Button from '@components/Button/Button';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  active: boolean;
  isDesktop: boolean;
  small: boolean;
  showrooms: Array<IPointOfPresence>;
  setShowroomUuid: (newShowroomUuid: string) => void;
};
const ShowroomsList = ({
  active,
  isDesktop,
  small,
  showrooms,
  setShowroomUuid
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const swiperInstance = useRef<SwiperClass>(null);
  const renderItemList = (item: IPointOfPresence): JSX.Element => <div sx={styles.itemList}>
      <span>{item?.address?.city}</span>
      <Heading h={1} size={18} uppercase pb={8} mobile>
        {getShowroomName(item, t)}
      </Heading>
      <span>
        {item?.address?.street}, {item?.address?.postalCode}
      </span>
    </div>;
  return <div sx={styles.container(active, small)}>
      {isDesktop && <>
          <Heading h={1} headingType={6} pb={16}>
            {t('showroomsFound', {
          quantity: showrooms.length
        })}
          </Heading>
          <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
        draggable: true,
        hide: false,
        dragSize: 80
      }} onSwiper={swiper => {
        swiperInstance.current = swiper;
      }} followFinger slidesPerView="auto" freeMode mousewheel>
            {showrooms.map(showroom => <SwiperSlide key={`${showroom.uuid}-${Math.random()}`} onClick={() => showroom?.uuid ? setShowroomUuid(showroom.uuid) : null}>
                {renderItemList(showroom)}
              </SwiperSlide>)}
          </Swiper>
        </>}
      {!isDesktop && showrooms.map(showroom => <Button variant="link" key={`${showroom.uuid}-${Math.random()}`} onClick={() => showroom?.uuid ? setShowroomUuid(showroom.uuid) : null}>
            {renderItemList(showroom)}
          </Button>)}
    </div>;
};
export default ShowroomsList;